import { list } from '../../../api/common';
import { showNotificationLayer } from '../../../actions/notification';
import { downloadCsv } from '../../../components';
import { formattedDateTime } from '../../../utils';

export const generateCsv = params =>
  dispatch => {
    dispatch(
      showNotificationLayer('Gerando Excel. Aguarde...')
    );

    list(params, 'parliamentary.amendment.php')
      .then(({ data: { data } }) => {
        downloadCsv({
          data,
          specifications: {
            year: { name: 'Ano', transform: (value) => value ?? '' },
            object: { name: 'Objeto', transform: (value) => value ?? '' },
            regionName: { name: 'Cidade', transform: (value) => value ?? '' },
            value: { name: 'Valor', transform: (value) => value ?? '' },
            stageName: { name: 'Estágio', transform: (value) => value ?? '' },
            createdAt: { name: 'Cadastro', transform: (value) => value ?? '' },
            updatedAt: { name: 'Atualização', transform: (value) => value ?? '' },
          },
          fileName: `listagem-emenda-${formattedDateTime(new Date(), 'DD-MM-YYYY-HH-mm')}.csv`,
        })
      })
      .catch((e) => {
        console.error(e);
        return dispatch(
          showNotificationLayer('Ops... não conseguimos gerar o Excel.')
        )
      });
  }
